document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.before-after__wrapper');
  if (!root) return;

  const container = root.closest('.before-afters__container');
  const track = root.closest('.custom-slider-container');
  const slides = [...track.querySelectorAll('.before-after__wrapper')];

  const next = container?.querySelector('.after-button');
  const prev = container?.querySelector('.before-button');

  let index = Math.floor(slides.length / 2);
  let width = 0;

  const move = (i, animate = true) => {
    index = Math.max(0, Math.min(i, slides.length - 1));

    const x =
      -(index * width) +
      (track.clientWidth / 2 - root.clientWidth / 2);

    track.style.transition = animate
      ? 'transform 350ms cubic-bezier(.22,.9,.35,1)'
      : 'none';

    track.style.transform = `translate3d(${x}px,0,0)`;

    slides.forEach((el, n) =>
      el.classList.toggle('active', n === index)
    );
  };

  const measure = () => {
    width = (slides[0]?.clientWidth || root.clientWidth) + 16;
    move(index, false);
  };

  slides.forEach((slide, i) =>
    slide.addEventListener('click', () => i !== index && move(i))
  );

  next?.addEventListener('click', () => move(index + 1));
  prev?.addEventListener('click', () => move(index - 1));

  new ResizeObserver(measure).observe(root);

  measure();
});